import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const DetailFooterDesc = () => {
  return (
    <div className={cx('DetailFooterDesc')}>
      <div className={cx('inner')}>
        <p className={cx('txt')}>
          좌석상태 및 요금(유류할증료, 제세공과금 등 포함) 등의 정보는 각
          여행사에서 제공한 정보이며, 예약현황, 유가, 환율 등에 따라 실시간
          변동되므로 네이버 검색결과와 여행사 홈페이지 정보에 차이가 있을 수
          있습니다.
        </p>
        <p className={cx('txt')}>
          항공권 예약 및 예약한 항공권의 확인, 결제, 발권은 선택하신 여행사의
          홈페이지에서 확인 가능하며, 예약전 요금규정(수하물, 환불, 마일리지
          등)을 반드시 확인하시기 바랍니다.
        </p>
        <p className={cx('txt')}>
          네이버는 항공권 검색 결과 및 구매에 대한 별도의 책임을 지지 않으며,
          항공권 예약, 결제, 발권, 취소 등에 대한 사항은 해당 여행사로
          문의하시기 바랍니다.
        </p>
      </div>
    </div>
  );
};

export default DetailFooterDesc;
